




























import {
  defineComponent,
  useContext,
  useFetch,
  reactive
} from '@nuxtjs/composition-api'
import useCookies from '~/composables/useCookies'
import useLogin from '~/composables/useLogin'
import Meta from '~/assets/mixins/meta'

export default defineComponent({
  middleware: ['not_authenticated'],
  mixins: [Meta],
  data() {
    return {
      meta: {
        title: 'ログイン',
        image: require('~/assets/images/school/ogp.jpg')
      }
    }
  },
  setup() {
    const { from } = useContext()
    const $cookies = useCookies()

    useFetch(() => {
      if ($cookies.get('afterLoginURL')) {
        return
      }

      const afterCareerRegistrationPath = $cookies.get<string | null>(
        'afterCareerRegistrationPath'
      )
      if (afterCareerRegistrationPath) {
        $cookies.set('afterLoginURL', afterCareerRegistrationPath, {
          domain: process.env.COOKIE_DOMAIN
        })
      } else {
        const path = from.value?.fullPath
        if (!/(sign_in|sign_up)$/.test(path)) {
          $cookies.set('afterLoginURL', path || '/', {
            domain: process.env.COOKIE_DOMAIN
          })
        }
      }
    })

    const {
      loginWithPassword,
      loginWithTwitter,
      loginWithFacebook,
      loginWithGoogle
    } = useLogin()

    const input = reactive({
      emailOrUsername: '',
      password: ''
    })

    const login = () => {
      loginWithPassword(input.emailOrUsername, input.password)
    }

    return {
      input,
      login,
      loginWithTwitter,
      loginWithFacebook,
      loginWithGoogle
    }
  }
})
